import React from 'react'

import { observer } from 'mobx-react-lite'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { H3 } from '@mxenabled/mxui'

import { ChevronRight as ChevronRightIcon } from '@mxenabled/mx-icons'

import { useCopyStore, useEvent } from '../context/hooks'
import { ANALYTICS_CLICK_EVENTS } from '../constants/Analytics'

import { Beat } from '../../core/types/Beat'
import { TheWholeHog } from '../interfaces'
import Loader from '../../common/components/Loader'
import { type SxProps } from '@mui/material/styles'

export interface CarouselHeaderProps {
  analyticsMetadata?: Record<string, string>
  onCardClick: (beat?: Beat | undefined) => void
  posthog?: TheWholeHog
  widthOverrides?: number | string
  headerSx?: SxProps
}

const CarouselHeader: React.FC<CarouselHeaderProps> = ({
  analyticsMetadata,
  onCardClick,
  posthog,
  widthOverrides,
  headerSx,
}) => {
  // *************** Context functions *********************
  const { carouselCopy: copy } = useCopyStore()
  const { onEvent } = useEvent()

  // *************** Click handlers ************************
  const handleViewAllClick = () => {
    if (onEvent) {
      onEvent(ANALYTICS_CLICK_EVENTS.ON_VIEW_MORE_CLICKED, analyticsMetadata)

      onCardClick()

      posthog?.capture('clicked_view_more')
    }
  }

  if (!copy) {
    return <Loader />
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      spacing={2}
      sx={{
        p: 16,
        pb: 8,
        width: widthOverrides ? widthOverrides : undefined,
        ...headerSx,
      }}
    >
      <H3>{copy.carousel_title}</H3>
      <Button
        endIcon={<ChevronRightIcon size={20} />}
        onClick={handleViewAllClick}
        size="small"
        variant="text"
      >
        {copy.view_all_insights_in_full_feed_cta_aria}
      </Button>
    </Stack>
  )
}

export default observer(CarouselHeader)
